module.exports = __webpack_public_path__ + "static/media/workoutsScreenshot.e3b39482.PNG";